import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=d2610082&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2610082')) {
      api.createRecord('d2610082', component.options)
    } else {
      api.reload('d2610082', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=d2610082&", function () {
      api.rerender('d2610082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/default/components/Main.vue"
export default component.exports